module.exports = __webpack_public_path__ + "static/img/1808_9.76d50a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_9.jpg
// module id = bnUJ
// module chunks = 1